import * as React from 'react'

import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import i18n from 'modules/core/lib/i18n'

import { getCustomFieldKey } from 'modules/contracts/lib/customFields'
import type ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'

interface Props {
  form: Form
  field: ResourceField
}

const DateCustomField = ({ form, field }: Props) => {
  return (
    <DayPicker
      mandatory={field.attributes.required}
      withNull={!field.attributes.required}
      label={field.attributes.label}
      field={form.get(getCustomFieldKey(field))}
      placeholder={i18n.t('employee_form.contract_select_date')}
    />
  )
}

export default observer(DateCustomField)
